<template>
    <div
        class="dropdown"
        :class="{'show' : dropDownState.active}"
        v-bind="$attrs"
        v-clickoutside="clickOutsideHandler"
    >
        <slot name="toggler" :toggle="toggle">
        </slot>
        <slot />
    </div>
</template>

<script setup>
import { ref, provide, watch } from "vue";

const emit = defineEmits(["toggle"]);


const props = defineProps({
    active: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    }
});

const dropDownState = ref({
    active: props.active
});

provide("dropDownState", dropDownState);

const clickOutsideHandler = () => {
    if (dropDownState.value.active) {
        dropDownState.value.active = false;
    }
}

const toggle = () => {
    if (props.readonly && !dropDownState.value.active) {
        return;
    }
    dropDownState.value.active = !dropDownState.value.active;
};

const away = () => {
    dropDownState.value.active = false;
};

watch(() => props.active, (newState) => {
    dropDownState.value.active = newState;
});

watch(() => dropDownState.value.active, () => {
    emit("toggle", dropDownState.value.active);
});

</script>

<style scoped>

</style>
